import Authenticate from './Authenticate.page';

export default Authenticate;